export class GATracker {
    static activeWrapper;

    constructor(trackingId, debug) {
        this.debug = debug;

        if (!window.ga) {
            // https://developers.google.com/analytics/devguides/collection/analyticsjs/
            window.GoogleAnalyticsObject = 'ga';
            window.ga = (...args) => (window.ga.q = window.ga.q || []).push(args);
            window.ga.l = 1 * new Date();

            const script = document.createElement('script');
            script.async = 1;
            script.src = 'https://www.google-analytics.com/analytics.js';
            document.body.appendChild(script);
        }

        window.ga('create', trackingId, 'auto', 'cielo24');
    }

    track(event) {
        let sessionControl;

        // Always start a new session with the first event
        if (GATracker.activeWrapper === undefined) {
            GATracker.activeWrapper = 'pending';
            sessionControl = 'start';

        // Only handle sessions for non initialization events
        } else if (event.category !== 'Initialization') {
            // The first non initialization event continues using the first session
            // Otherwise we start a new session if the source wrapper changed
            if (GATracker.activeWrapper !== 'pending' && GATracker.activeWrapper !== event.wrapperId) {
                sessionControl = 'start';
            }

            // Now we really start session handling based on the active wrapper
            GATracker.activeWrapper = event.wrapperId;
        }

        if (this.debug) {
            /* eslint-disable no-console */
            if (sessionControl === 'start') {
                console.log('%c tracker: starting new session', 'color: gray; font-weight: bold;');
            }

            console.groupCollapsed(`%c tracker: ${event.category} > ${event.action}`, 'color: gray');
            console.log('Category:', event.category);
            console.log('Action:', event.action);
            if (event.label) console.log('Label:', event.label);
            if (event.value) console.log('Value:', event.value);
            console.log('Complete event data:', event);
            console.groupEnd();
            /* eslint-enable no-console */
        }

        window.ga('cielo24.send', 'event', event.category, event.action, event.label, event.value, {
            dimension1: event.domain,
            dimension2: event.url,
            dimension3: event.videoId,
            dimension4: event.playerType,
            dimension5: event.playerSubtype,
            dimension6: event.elementListId,
            dimension7: event.elementListLanguage,
            dimension8: event.interfaceLanguage,
            dimension9: event.transcriptVisible,
            dimension10: event.captionsVisible,
            dimension11: event.heatmapVisible,
            dimension12: event.speakersVisible,
            metric1: event.videoDuration,
            metric2: event.videoCurrentTime,
            metric3: event.videoCurrentTimeNormalized,
            sessionControl,
        });
    }
}



// WEBPACK FOOTER //
// ./scripts/tracking/trackers.js